import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dayContainer", "rangesContainer", "rangeTemplate"];

  toggleClosed(event) {
    const checkbox = event.currentTarget;
    const dayContainer = checkbox.closest("[data-day]");
    const rangesContainer = dayContainer.querySelector(
      "[data-business-hours-editor-target='rangesContainer']"
    );

    if (checkbox.checked) {
      rangesContainer.classList.add("hidden");
    } else {
      rangesContainer.classList.remove("hidden");
    }
  }

  applyToAll(event) {
    event.preventDefault();
    const sourceContainer = event.currentTarget.closest("[data-day]");
    const sourceDay = sourceContainer.dataset.day;

    const sourceClosed = sourceContainer.querySelector(
      "input[type='checkbox'][name*='[closed]']"
    ).checked;
    const sourceRanges = this._readRanges(sourceContainer);

    this.dayContainerTargets.forEach((targetContainer) => {
      if (targetContainer.dataset.day === sourceDay) return;

      const targetDay = targetContainer.dataset.day;

      const closedCheckbox = targetContainer.querySelector(
        "input[type='checkbox'][name*='[closed]']"
      );
      closedCheckbox.checked = sourceClosed;

      const rangesContainer = targetContainer.querySelector(
        "[data-business-hours-editor-target='rangesContainer']"
      );

      if (sourceClosed) {
        rangesContainer.classList.add("hidden");
      } else {
        rangesContainer.classList.remove("hidden");
        this._replaceRanges(rangesContainer, targetDay, sourceRanges);
      }

      targetContainer.classList.add("ring-2", "ring-black", "ring-offset-1");
      setTimeout(() => {
        targetContainer.classList.remove(
          "ring-2",
          "ring-black",
          "ring-offset-1"
        );
      }, 800);
    });
  }

  addRange(event) {
    event.preventDefault();
    const dayContainer = event.currentTarget.closest("[data-day]");
    const day = dayContainer.dataset.day;
    const rangesContainer = dayContainer.querySelector(
      "[data-business-hours-editor-target='rangesContainer']"
    );
    const rangeRows = rangesContainer.querySelectorAll("[data-range-row]");
    const newIndex = rangeRows.length;

    const row = this._buildRangeRow(day, newIndex);
    rangesContainer.insertBefore(
      row,
      rangesContainer.querySelector("[data-add-range]")
    );
  }

  removeRange(event) {
    event.preventDefault();
    const row = event.currentTarget.closest("[data-range-row]");
    const rangesContainer = row.closest(
      "[data-business-hours-editor-target='rangesContainer']"
    );
    const remainingRows =
      rangesContainer.querySelectorAll("[data-range-row]");

    // Don't remove the last range row
    if (remainingRows.length <= 1) return;

    row.remove();
  }

  // --- Private helpers ---

  _readRanges(dayContainer) {
    const rows = dayContainer.querySelectorAll("[data-range-row]");
    return Array.from(rows).map((row) => {
      const inputs = row.querySelectorAll("input[type='time']");
      return {
        open: inputs[0]?.value || "",
        close: inputs[1]?.value || "",
      };
    });
  }

  _replaceRanges(rangesContainer, day, sourceRanges) {
    rangesContainer
      .querySelectorAll("[data-range-row]")
      .forEach((row) => row.remove());

    const addRangeButton = rangesContainer.querySelector("[data-add-range]");

    sourceRanges.forEach((range, index) => {
      const row = this._buildRangeRow(day, index, range.open, range.close);
      rangesContainer.insertBefore(row, addRangeButton);
    });
  }

  _buildRangeRow(day, index, openValue = "", closeValue = "") {
    const row = document.createElement("div");
    row.setAttribute("data-range-row", "");
    row.className = `flex items-center gap-2${index > 0 ? " mt-2" : ""}`;

    const removeButton =
      index > 0
        ? `<button type="button" data-action="click->business-hours-editor#removeRange"
              class="p-1 text-gray-400 hover:text-red-500 transition-colors" title="Remove range">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>`
        : "";

    row.innerHTML = `
      <input type="time" name="organization[business_hours_schedule][${day}][ranges][${index}][open]"
             value="${openValue}"
             class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-black focus:border-black" />
      <span class="text-sm text-gray-400">to</span>
      <input type="time" name="organization[business_hours_schedule][${day}][ranges][${index}][close]"
             value="${closeValue}"
             class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-black focus:border-black" />
      ${removeButton}
    `;

    return row;
  }
}
